// Swatch variant picker logic for Shopify themes

class SwatchVariantPicker extends HTMLElement {
  connectedCallback() {
    this.updateVariantIdInput();
    this.updateSoldOutState();
    this.addEventListener('change', this.handleChange.bind(this));
  }

  /**
   * @param {Event & { target: Element }} event
   */
  handleChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;

    if (target.classList.contains('swatch-variant-input') && target.checked) {
      this.updateVariantIdInput(target.dataset.variantId);
      this.updateSoldOutState();
    }
  }

  /**
   * @param {string=} variantId
   */
  updateVariantIdInput(variantId) {
    /** @type {HTMLInputElement | null} */
    const variantIdInput = document.querySelector('input[name="id"]');
    if (!variantIdInput) return;
    if (variantId) {
      variantIdInput.value = variantId;
    } else {
      // Set to checked swatch on load
      /** @type {HTMLInputElement | null} */
      const checkedInput = this.querySelector('.swatch-variant-input:checked');
      if (checkedInput && checkedInput.dataset.variantId) {
        variantIdInput.value = checkedInput.dataset.variantId;
      }
    }
  }

  updateSoldOutState() {
    const productForm = this.closest('product-form-component');
    if (!productForm) return;

    /** @type {HTMLInputElement | null} */
    const checkedInput = this.querySelector('.swatch-variant-input:checked');
    let isSoldOut = false;

    if (checkedInput) {
      const available = checkedInput.dataset.available;
      isSoldOut = available === 'false';
    } else {
      // If nothing is checked (e.g., all variants are unavailable), treat as sold out
      isSoldOut = true;
    }

    if (isSoldOut) {
      productForm.classList.add('variant-sold-out');
    } else {
      productForm.classList.remove('variant-sold-out');
    }

    /** @type {HTMLButtonElement | null} */
    const addToCartBtn = productForm.querySelector('.vinyl-add-to-cart');
    if (addToCartBtn) addToCartBtn.disabled = isSoldOut;

    /** @type {HTMLElement | null} */
    const cartControls = productForm.querySelector('.vinyl-cart-controls');
    if (cartControls) cartControls.classList.toggle('disabled', isSoldOut);

    // Disable/enable quantity controls while sold out
    const quantityContainer = productForm.querySelector('.vinyl-quantity-container');
    if (quantityContainer) {
      /** @type {(HTMLButtonElement|HTMLInputElement)[]} */
      const controls = Array.from(quantityContainer.querySelectorAll('button, input'));
      controls.forEach((el) => {
        if (el instanceof HTMLButtonElement || el instanceof HTMLInputElement) {
          el.disabled = isSoldOut;
        }
      });
    }
  }
}

if (!customElements.get('swatch-variant-picker')) {
  customElements.define('swatch-variant-picker', SwatchVariantPicker);
}
